export default {
  // Customers
  customers: {
    createNew: 'สร้างลูกค้าใหม่',
    phoneNumber: 'หมายเลขโทรศัพท์',
    name: 'ชื่อลูกค้า',
    enterName: 'กรอกชื่อลูกค้า',
    externalReference: 'อ้างอิงภายนอก',
    enterExternalReference: 'กรอกอ้างอิงภายนอก (ไม่บังคับ)',
    search: 'ค้นหาลูกค้า',
    noResults: 'ไม่พบลูกค้า',
    create: 'สร้างลูกค้า',
    edit: 'แก้ไขลูกค้า',
    details: 'รายละเอียดลูกค้า',
    contactInfo: 'ข้อมูลติดต่อ'
  },

  // Languages
  languages: {
    en: 'English',
    my: 'မြန်မာ',
    th: 'ไทย'
  },

  // Notifications
  notifications: {
    disableSound: 'ปิดเสียงการแจ้งเตือน',
    enableSound: 'เปิดเสียงการแจ้งเตือน',
    newTicket: 'สร้างตั๋วใหม่แล้ว',
    ticketUpdated: 'ตั๋ว #{{id}} ถูกอัปเดต',
    ticketAssigned: 'ตั๋วถูกมอบหมายให้คุณ',
    ticketResolved: 'ตั๋วได้รับการแก้ไขแล้ว',
    ticketClosed: 'ตั๋วถูกปิดแล้ว',
    received: 'ได้รับการแจ้งเตือน',
    markAllReadError: 'ไม่สามารถทำเครื่องหมายการแจ้งเตือนทั้งหมดว่าอ่านแล้ว กรุณาลองใหม่อีกครั้ง',
    noAssociatedTicket: 'การแจ้งเตือนนี้ไม่มีตั๋วที่เกี่ยวข้อง',
    navigationError: 'ไม่สามารถนำทางไปยังตั๋วได้ กรุณาลองใหม่อีกครั้ง'
  },

  // Authentication
  auth: {
    loginFailed: 'เข้าสู่ระบบไม่สำเร็จ',
    organizationSubdomain: 'ซับโดเมนขององค์กร',
    subdomainRequired: 'จำเป็นต้องระบุซับโดเมนขององค์กร',
    invalidSubdomain: 'รูปแบบซับโดเมนไม่ถูกต้อง',
    subdomainPlaceholder: 'องค์กรของคุณ',
    subdomainHelpText:
      'กรอกซับโดเมนขององค์กรเพื่อเชื่อมต่อกับเทนแนนต์ที่ถูกต้อง หากคุณไม่ทราบซับโดเมนขององค์กร กรุณาติดต่อผู้ดูแลระบบ',
    loggingIntoOrg: 'คุณกำลังเข้าสู่ระบบใน',
    devMode: '(โหมดพัฒนาท้องถิ่น)',
    emailAddress: 'ที่อยู่อีเมล',
    emailRequired: 'จำเป็นต้องระบุอีเมล',
    invalidEmail: 'ที่อยู่อีเมลไม่ถูกต้อง',
    emailPlaceholder: 'you@example.com',
    password: 'รหัสผ่าน',
    passwordRequired: 'จำเป็นต้องระบุรหัสผ่าน',
    passwordMinLength: 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร',
    passwordPlaceholder: 'กรอกรหัสผ่านของคุณ',
    forgotPassword: 'ลืมรหัสผ่าน?',
    signingIn: 'กำลังเข้าสู่ระบบ...',
    signIn: 'เข้าสู่ระบบ',
    forgotPasswordTitle: 'ลืมรหัสผ่าน?',
    contactAdmin: 'กรุณาติดต่อผู้ดูแลระบบเพื่อรีเซ็ตรหัสผ่านของคุณ',
    email: 'อีเมล: ',
    phone: 'โทรศัพท์: '
  },

  // Forms
  forms: {
    fieldRequired: 'จำเป็นต้องระบุ {{field}}',
    selectField: 'เลือก {{field}}',
    enterToSearch: 'กด Enter เพื่อค้นหา',
    priorityLevel: 'ระดับความสำคัญ',
    priorityLevelDescription: 'ระบุระดับความสำคัญของเคสนี้',
    ticketMainInfo: 'การจัดประเภท',
    ticketMainInfoDescription: 'ใส่แท็กและเลือกหมวดหมู่ให้กับตั๋วนี้',
    assignmentTitle: 'การมอบหมาย',
    assignmentDescription: 'มอบหมายตั๋วนี้ให้กับตัวแทนที่เกี่ยวข้อง',
    ticketDetailTitle: 'รายละเอียดตั๋ว',
    ticketDetailDescription: 'เพิ่มคำอธิบาย เทมเพลต และไฟล์แนบ',
    description: 'คำอธิบายตั๋ว',
    attachments: 'ไฟล์แนบ',
    validation: {
      required: 'ช่องนี้จำเป็นต้องกรอก',
      minLength: 'ต้องมีอย่างน้อย {{min}} ตัวอักษร',
      maxLength: 'ต้องไม่เกิน {{max}} ตัวอักษร',
      invalidFormat: 'รูปแบบไม่ถูกต้อง'
    }
  },

  // Common UI elements
  common: {
    loading: 'กำลังโหลด...',
    error: 'เกิดข้อผิดพลาด',
    success: 'สำเร็จ',
    noData: 'ไม่มีข้อมูล',
    none: 'ไม่มี',
    email: 'อีเมล',
    phone: 'โทรศัพท์',
    createTicket: 'สร้างตั๋ว',
    submit: 'ส่ง',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    close: 'ปิด',
    confirm: 'ยืนยัน',
    search: 'ค้นหา',
    filter: 'กรอง',
    reset: 'รีเซ็ต',
    apply: 'ใช้',
    to: 'ถึง',
    create: 'สร้าง',
    creating: 'กำลังสร้าง...',
    settings: 'การตั้งค่า',
    appLogo: 'โลโก้ FlowCXP',
    appName: 'FlowCXP',
    profile: 'โปรไฟล์',
    logout: 'ออกจากระบบ',
    notifications: 'การแจ้งเตือน',
    markAllAsRead: 'ทำเครื่องหมายทั้งหมดว่าอ่านแล้ว',
    noNotifications: 'ไม่มีการแจ้งเตือนที่ยังไม่ได้อ่าน',
    connected: 'เชื่อมต่อแล้ว',
    disconnected: 'ขาดการเชื่อมต่อ',
    connectionError: 'ข้อผิดพลาดการเชื่อมต่อ',
    language: 'ภาษา',
    lightMode: 'โหมดสว่าง',
    darkMode: 'โหมดมืด',
    fullScreen: 'เต็มหน้าจอ',
    exitFullScreen: 'ออกจากเต็มหน้าจอ',
    changeLanguage: 'เปลี่ยนภาษา',
    localizationTest: 'หน้าทดสอบการแปลภาษา',
    currentSettings: 'การตั้งค่าปัจจุบัน',
    currentLanguage: 'ภาษาปัจจุบัน',
    currentTheme: 'ธีมปัจจุบัน',
    dark: 'มืด',
    light: 'สว่าง',
    translationSamples: 'ตัวอย่างการแปล',
    commonElements: 'องค์ประกอบ UI ทั่วไป',
    apiExamples: 'ตัวอย่างการจัดรูปแบบวันที่ API',
    accessDenied: 'การเข้าถึงถูกปฏิเสธ',
    accessDeniedMessage: 'คุณไม่มีสิทธิ์เข้าถึงทรัพยากรนี้ กรุณาติดต่อผู้ดูแลระบบ',
    returnToDashboard: 'กลับสู่แดชบอร์ด',
    previous: 'ก่อนหน้า',
    next: 'ถัดไป',
    showing: 'แสดง',
    of: 'จาก',
    results: 'ผลลัพธ์',
    page: 'หน้า',
    perPage: 'ต่อหน้า',
    noResults: 'ไม่พบผลลัพธ์',
    errorGeneric: 'เกิดข้อผิดพลาดบางอย่าง',
    errorUnexpected: 'เกิดข้อผิดพลาดที่ไม่คาดคิด',
    applicationError: 'ข้อผิดพลาดของแอปพลิเคชัน',
    goBack: 'กลับ',
    goHome: 'กลับหน้าหลัก',
    unknown: 'ไม่ทราบ',
    test: 'ทดสอบ',
    testing: 'กำลังทดสอบ...'
  },

  // Tenant Information
  tenantInfo: {
    organizationInformation: 'ข้อมูลองค์กร',
    active: 'ใช้งานอยู่',
    organizationName: 'ชื่อองค์กร',
    subdomain: 'ซับโดเมน',
    tenantId: 'รหัสผู้เช่า',
    totalAgents: 'เอเจนต์ทั้งหมด'
  },

  // Pages
  pages: {
    login: {
      title: 'เข้าสู่ระบบ',
      welcomeBack: 'ยินดีต้อนรับกลับมา!',
      signInToContinue: 'เข้าสู่ระบบเพื่อดำเนินการต่อ',
      newToApp: 'ใหม่กับแอป?',
      registerOrg: 'ลงทะเบียนองค์กร',
      loggingIn: 'กำลังเข้าสู่ระบบ...',
      loginFailed: 'เข้าสู่ระบบไม่สำเร็จ',
      organizationSubdomain: 'ซับโดเมนขององค์กร',
      subdomainRequired: 'จำเป็นต้องระบุซับโดเมนขององค์กร',
      invalidSubdomain: 'รูปแบบซับโดเมนไม่ถูกต้อง',
      subdomainPlaceholder: 'องค์กรของคุณ',
      subdomainHelpText:
        'กรอกซับโดเมนขององค์กรเพื่อเชื่อมต่อกับเทนแนนต์ที่ถูกต้อง หากคุณไม่ทราบซับโดเมนขององค์กร กรุณาติดต่อผู้ดูแลระบบ',
      loggingIntoOrg: 'คุณกำลังเข้าสู่ระบบใน',
      devMode: '(โหมดพัฒนาท้องถิ่น)',
      emailAddress: 'ที่อยู่อีเมล',
      emailRequired: 'จำเป็นต้องระบุอีเมล',
      invalidEmail: 'ที่อยู่อีเมลไม่ถูกต้อง',
      emailPlaceholder: 'you@example.com',
      password: 'รหัสผ่าน',
      passwordRequired: 'จำเป็นต้องระบุรหัสผ่าน',
      passwordMinLength: 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร',
      passwordPlaceholder: 'กรอกรหัสผ่านของคุณ',
      forgotPassword: 'ลืมรหัสผ่าน?',
      signingIn: 'กำลังเข้าสู่ระบบ...',
      signIn: 'เข้าสู่ระบบ',
      forgotPasswordTitle: 'ลืมรหัสผ่าน?',
      contactAdmin: 'กรุณาติดต่อผู้ดูแลระบบเพื่อรีเซ็ตรหัสผ่านของคุณ',
      email: 'อีเมล: ',
      phone: 'โทรศัพท์: '
    },
    createTicket: {
      title: 'สร้างตั๋ว',
      description: 'กรอกข้อมูลเพื่อเปิดเคสซัพพอร์ตใหม่',
      createButton: 'สร้างตั๋ว',
      error: 'ไม่สามารถสร้างตั๋วได้ กรุณาลองใหม่อีกครั้ง',
      fields: {
        title: 'หัวข้อ',
        titlePlaceholder: 'กรอกหัวข้อตั๋ว',
        titleToggle: {
          auto: 'สร้างอัตโนมัติ',
          manual: 'กรอกด้วยตนเอง'
        },
        description: 'คำอธิบาย',
        descriptionPlaceholder: 'อธิบายปัญหาหรือคำขอของคุณ',
        searchCustomer: 'ค้นหาลูกค้า',
        searchCustomerByPhone: 'ค้นหาลูกค้าด้วยหมายเลขโทรศัพท์',
        searching: 'กำลังค้นหา...',
        search: 'ค้นหา',
        select: 'เลือก',
        edit: 'แก้ไข',
        foundCustomers: 'พบลูกค้า {{count}} คน',
        foundCustomersPlural: 'พบลูกค้า {{count}} คน',
        loadingTags: 'กำลังโหลดแท็ก...',
        noTagsAvailable: 'ไม่มีแท็ก',
        typeAtLeastOneChar: 'กรอกรหัสผ่านของคุณ',
        noMatchingTags: 'ไม่พบแท็ก',
        tagPlaceholder: 'เลือกหรือค้นหาแท็ก...',
        priority: 'ความสำคัญ',
        type: 'ประเภท',
        category: 'หมวดหมู่',
        source: 'แหล่งที่มา',
        group: 'กลุ่ม',
        customer: 'ลูกค้า',
        assignedTo: 'มอบหมายให้',
        tags: 'แท็ก',
        attachments: 'ไฟล์แนบ',
        selectCustomer: 'เลือกลูกค้า',
        selectAssignee: 'เลือกผู้รับผิดชอบ',
        selectTemplate: 'เลือกแม่แบบฟอร์ม',
        loadingTemplates: 'กำลังโหลดแม่แบบ...',
        notifyCustomer: 'แจ้งเตือนลูกค้า',
        notifyCustomerDescription: 'แจ้งเตือนลูกค้าเกี่ยวกับตั๋วผ่านการแจ้งเตือนแบบพุช'
      }
    },
    tickets: {
      title: 'ตั๋ว',
      tags: 'แท็ก',
      groups: 'กลุ่ม',
      categories: 'หมวดหมู่',
      sources: 'แหล่งที่มา',
      totalTickets: 'ตั๋วทั้งหมด',
      allStatuses: 'สถานะทั้งหมด',
      requestedBy: 'ขอโดย',
      assignedTo: 'มอบหมายให้',
      filterByGroups: 'กรองตามกลุ่ม...',
      filterByRequesters: 'กรองตามผู้ขอ...',
      filterByAssignees: 'กรองตามผู้รับผิดชอบ...',
      filterByTags: 'กรองตามแท็ก...',
      filterByCategories: 'กรองตามหมวดหมู่...',
      filterBySources: 'กรองตามแหล่งที่มา...',
      searchTickets: 'ค้นหาตั๋ว...',
      noTicketsFound: 'ไม่พบตั๋ว',
      noTicketsMessage: 'ไม่มีตั๋วที่ตรงกับเกณฑ์การค้นหาของคุณ',
      createFirstTicket: 'สร้างตั๋วแรกของคุณเพื่อเริ่มต้น',
      adjustFilters: 'ลองปรับเกณฑ์การกรองของคุณ',
      clearFilters: 'ล้างตัวกรอง',
      tryDifferentSearch: 'ลองใช้คำค้นหาที่แตกต่างกัน',
      createFirstMemo: 'สร้างบันทึกแรกของคุณเพื่อเริ่มต้น',
      createNewMemo: 'สร้างบันทึกใหม่'
    },
    ticketWall: {
      title: 'กำแพงตั๋ว'
    },
    ticketDetail: {
      saveChanges: 'บันทึกการเปลี่ยนแปลง',
      editTicket: 'แก้ไขตั๋ว',
      cancel: 'ยกเลิก',
      ticketHistory: 'ประวัติตั๋ว',
      ticketDetail: 'รายละเอียดตั๋ว',
      unassigned: 'ยังไม่ได้มอบหมาย',
      assignToMe: 'มอบหมายให้ฉัน',
      type: 'ประเภท',
      category: 'หมวดหมู่',
      priority: 'ความสำคัญ',
      source: 'แหล่งที่มา',
      requester: 'ผู้ขอ',
      customer: 'ลูกค้า',
      group: 'กลุ่ม',
      assignee: 'ผู้รับผิดชอบ',
      tags: 'แท็ก',
      attachments: 'ไฟล์แนบ',
      noAttachments: 'ไม่มีไฟล์แนบ',
      newAttachmentsPreview: 'แสดงตัวอย่างไฟล์แนบใหม่',
      currentAttachments: 'ไฟล์แนบปัจจุบัน',
      addNewAttachments: 'เพิ่มไฟล์แนบใหม่',
      discussion: 'การอภิปราย',
      deleteTicket: 'ลบตั๋ว',
      ticketUpdatedByAnotherUser:
        'ตั๋วได้รับการอัปเดตโดยผู้ใช้รายอื่นแล้ว กรุณายกเลิกการแก้ไขปัจจุบันและลองใหม่อีกครั้ง'
    },
    dashboard: {
      title: 'แดชบอร์ด',
      overview: 'ภาพรวม',
      topContributors: 'ผู้มีส่วนร่วมอันดับต้น',
      recentActivity: 'กิจกรรมล่าสุด',
      ticketBreakdown: 'การแบ่งแยกตั๋ว',
      quickStats: 'สถิติด่วน',
      totalTickets: 'ตั๋วทั้งหมด',
      openTickets: 'ตั๋วเปิด',
      inProgressTickets: 'ตั๋วกำลังดำเนินการ',
      resolvedTickets: 'ตั๋วที่แก้ไขแล้ว',
      closedTickets: 'ตั๋วปิด',
      ticketTrends: 'แนวโน้มตั๋ว',
      last30Days: '30 วันที่ผ่านมา',
      ticketsCreated: 'ตั๋วที่สร้าง',
      ticketsResolved: 'ตั๋วที่แก้ไข',
      avgResolutionTime: 'เวลาแก้ไขเฉลี่ย',
      hours: 'ชั่วโมง',
      minutes: 'นาที',
      days: 'วัน',
      enhancedDashboard: 'แดชบอร์ดขั้นสูง',
      allTimeTotal: 'ยอดรวมตลอดเวลา',
      dayAverage: '/วัน เฉลี่ย',
      backlogGrew: 'งานค้างเพิ่มขึ้น',
      backlogShrank: 'งานค้างลดลง',
      stable: 'เสถียร',
      resolutionRate: 'อัตราการแก้ไข',
      requester: 'ผู้ขอ',
      customer: 'ลูกค้า',
      group: 'กลุ่ม',
      assignee: 'ผู้รับผิดชอบ',
      tags: 'แท็ก',
      attachments: 'ไฟล์แนบ',
      ticketHistory: 'ประวัติตั๋ว',
      editTicket: 'แก้ไขตั๋ว',
      failedToLoadStats: 'ไม่สามารถโหลดสถิติแดชบอร์ดได้'
    },
    myWorkspace: {
      title: 'พื้นที่ทำงานของฉัน',
      myOpenTickets: 'ตั๋วเปิดของฉัน',
      myAssignedTickets: 'ตั๋วที่มอบหมายให้ฉัน',
      openTicketsDescription: 'ตั๋วที่คุณสร้าง',
      assignedTicketsDescription: 'ตั๋วที่มอบหมายให้คุณ',
      noOpenTickets: 'คุณไม่มีตั๋วเปิด',
      noAssignedTickets: 'คุณไม่มีตั๋วที่ได้รับมอบหมาย',
      createYourFirstTicket: 'สร้างตั๋วแรกของคุณ',
      waitForAssignment: 'รอการมอบหมายตั๋ว',
      totalOpen: 'เปิดทั้งหมด',
      totalAssigned: 'มอบหมายทั้งหมด'
    },
    contact: {
      title: 'ติดต่อ',
      subtitle: 'ติดต่อทีมของเรา',
      contactInfo: 'ข้อมูลติดต่อ',
      officeHours: 'เวลาทำการ',
      headquarters: 'สำนักงานใหญ่',
      contactForm: 'แบบฟอร์มติดต่อ',
      sendMessage: 'ส่งข้อความ'
    },
    myMemo: {
      title: 'บันทึกของฉัน',
      createMemo: 'สร้างบันทึก',
      editMemo: 'แก้ไขบันทึก',
      deleteMemo: 'ลบบันทึก',
      newMemo: 'บันทึกใหม่',
      arrangeInGrid: 'จัดเรียงในตาราง',
      loadError: 'ไม่สามารถโหลดบันทึก',
      createError: 'ไม่สามารถสร้างบันทึก',
      updateError: 'ไม่สามารถอัปเดตบันทึก',
      deleteError: 'ไม่สามารถลบบันทึก',
      loginRequired: 'กรุณาเข้าสู่ระบบเพื่อดูบันทึกของคุณ',
      searchPlaceholder: 'ค้นหาบันทึก...',
      memoCount: 'บันทึก {{count}} รายการ',
      noMemos: 'ยังไม่มีบันทึก',
      noMatchingMemos: 'ไม่มีบันทึกที่ตรงกัน',
      tryDifferentSearch: 'ลองใช้คำค้นหาที่แตกต่างกัน',
      createFirstMemo: 'สร้างบันทึกแรกของคุณเพื่อเริ่มต้น',
      createNewMemo: 'สร้างบันทึกใหม่'
    },
    changePassword: {
      title: 'เปลี่ยนรหัสผ่าน',
      currentPassword: 'รหัสผ่านปัจจุบัน',
      newPassword: 'รหัสผ่านใหม่',
      confirmPassword: 'ยืนยันรหัสผ่าน',
      success: 'เปลี่ยนรหัสผ่านสำเร็จ',
      failedToChange: 'ไม่สามารถเปลี่ยนรหัสผ่าน',
      validation: {
        currentRequired: 'จำเป็นต้องระบุรหัสผ่านปัจจุบัน',
        minLength: 'รหัสผ่านใหม่ต้องมีอย่างน้อย 6 ตัวอักษร',
        maxLength: 'รหัสผ่านใหม่ต้องไม่เกิน 50 ตัวอักษร',
        confirmRequired: 'กรุณายืนยันรหัสผ่านใหม่ของคุณ',
        passwordsDontMatch: 'รหัสผ่านไม่ตรงกัน'
      },
      submit: 'บันทึก'
    },
    reports: {
      title: 'รายงาน',
      ticketStats: 'สถิติตั๋ว',
      exportData: 'ส่งออกข้อมูล',
      dateRangeReport: 'รายงานช่วงวันที่',
      ticketsExport: 'ตั๋ว',
      exporting: 'กำลังส่งออก...',
      export: 'ส่งออก'
    },
    privacyPolicy: {
      title: 'นโยบายความเป็นส่วนตัว'
    },
    termsOfService: {
      title: 'ข้อกำหนดการใช้บริการ'
    }
  },

  // Navigation
  navigation: {
    backTo: 'กลับไป',
    dashboard: 'แดชบอร์ด',
    tickets: 'ตั๋ว',
    ticketWall: 'กำแพงตั๋ว',
    myWorkspace: 'พื้นที่ทำงานของฉัน',
    reports: 'รายงาน',
    settings: 'การตั้งค่า',
    myMemo: 'บันทึกของฉัน',
    myMemos: 'บันทึกของฉัน',
    enhancedDashboard: 'แดชบอร์ดขั้นสูง',
    logout: 'ออกจากระบบ',
    contact: 'ติดต่อ',
    backToHome: 'กลับหน้าหลัก',
    privacyPolicy: 'นโยบายความเป็นส่วนตัว',
    termsOfService: 'ข้อกำหนดการใช้บริการ',
    localizationTest: 'ทดสอบการแปลภาษา',
    features: 'คุณสมบัติ',
    pricing: 'ราคา',
    atrium: 'The Atrium'
  },

  // Date and Time
  dateTime: {
    title: 'การจัดรูปแบบวันที่และเวลา',
    dateFormat: 'd MMM yyyy',
    timeFormat: 'HH:mm',
    dateTimeFormat: 'd MMM yyyy HH:mm',
    today: 'วันนี้',
    yesterday: 'เมื่อวาน',
    tomorrow: 'พรุ่งนี้',
    now: 'ตอนนี้',
    justNow: 'เมื่อกี้',
    invalidDateRange: 'วันที่เริ่มต้นต้องมาก่อนหรือเท่ากับวันที่สิ้นสุด',
    minutesAgo: '{{count}} นาทีที่แล้ว',
    minutesAgo_plural: '{{count}} นาทีที่แล้ว',
    hoursAgo: '{{count}} ชั่วโมงที่แล้ว',
    hoursAgo_plural: '{{count}} ชั่วโมงที่แล้ว',
    daysAgo: '{{count}} วันที่แล้ว',
    daysAgo_plural: '{{count}} วันที่แล้ว',
    weeksAgo: '{{count}} สัปดาห์ที่แล้ว',
    weeksAgo_plural: '{{count}} สัปดาห์ที่แล้ว',
    monthsAgo: '{{count}} เดือนที่แล้ว',
    monthsAgo_plural: '{{count}} เดือนที่แล้ว',
    yearsAgo: '{{count}} ปีที่แล้ว',
    yearsAgo_plural: '{{count}} ปีที่แล้ว',
    formats: 'รูปแบบวันที่',
    currentDate: 'วันที่ปัจจุบัน',
    currentDateTime: 'วันที่และเวลาปัจจุบัน',
    apiFormat: 'รูปแบบ API',
    systemTime: 'เวลาระบบ',
    apiFormats: 'รูปแบบวันที่ API ด้วยเขตเวลาพม่า',
    startOfDay: 'เริ่มต้นวัน',
    endOfDay: 'สิ้นสุดวัน',
    startOfDayDesc: 'กำหนดเวลาเป็น 00:00:00 ด้วยเขตเวลา +06:30',
    endOfDayDesc: 'กำหนดเวลาเป็น 23:59:59 ด้วยเขตเวลา +06:30',
    dateRangeExample: 'ตัวอย่างช่วงวันที่',
    apiRequestExample: 'ตัวอย่างคำขอ API',
    apiDateComment: 'เขตเวลาพม่า (UTC+06:30) ถูกกำหนดไว้อย่างชัดเจนสำหรับคำขอ API'
  },

  // Tickets
  tickets: {
    title: 'หัวข้อ',
    kanban: {
      dragToReorder: 'ลากเพื่ออัปเดตสถานะ'
    },
    status: {
      filterTitle: 'สถานะ',
      all: 'ทั้งหมด',
      new: 'ใหม่',
      unassigned: 'ไม่มีผู้รับผิดชอบ',
      processing: 'กำลังดำเนินการ',
      resolved: 'แก้ไขแล้ว',
      closed: 'ปิด'
    },
    priority: 'ความสำคัญ',
    assignedTo: 'มอบหมายให้',
    requestedBy: 'ขอโดย',
    filterByGroups: 'กรองตามกลุ่ม...',
    filterByRequesters: 'กรองตามผู้ขอ...',
    filterByAssignees: 'กรองตามผู้รับผิดชอบ...',
    noUsersAvailable: 'ไม่มีผู้ใช้',
    typeAtLeastOneChar: 'พิมพ์อย่างน้อย 1 ตัวอักษร',
    noMatchingUsers: 'ไม่พบผู้ใช้ที่ตรงกัน',
    loadingUsers: 'กำลังโหลดผู้ใช้...',
    allStatuses: 'สถานะทั้งหมด',
    createdAt: 'สร้างเมื่อ',
    updatedAt: 'อัปเดตเมื่อ',
    createdBy: 'สร้างโดย',
    dueDate: 'วันที่ครบกำหนด',
    category: 'หมวดหมู่',
    type: 'ประเภท',
    source: 'แหล่งที่มา',
    group: 'กลุ่ม',
    tags: 'แท็ก',
    description: 'คำอธิบาย',
    comments: 'ความคิดเห็น',
    attachments: 'ไฟล์แนบ',
    addComment: 'เพิ่มความคิดเห็น',
    adding: 'กำลังเพิ่ม...',
    commentRequired: 'กรุณากรอกความคิดเห็น',
    commentMinLength: 'ความคิดเห็นต้องมีอย่างน้อย 3 ตัวอักษร',
    commentPlaceholder: 'พิมพ์ความคิดเห็นของคุณที่นี่...',
    addAttachment: 'เพิ่มไฟล์แนบ',
    updateStatus: 'อัปเดตสถานะ',
    updatePriority: 'อัปเดตความสำคัญ',
    assign: 'มอบหมาย',
    unassign: 'ยกเลิกการมอบหมาย',
    created: 'สร้าง',
    lastUpdated: 'อัปเดตล่าสุด',
    open: 'เปิด',
    inProgress: 'กำลังดำเนินการ',
    resolved: 'แก้ไขแล้ว',
    closed: 'ปิด',
    reopened: 'เปิดใหม่',
    low: 'ต่ำ',
    medium: 'ปานกลาง',
    high: 'สูง',
    urgent: 'เร่งด่วน',
    noTicketsFound: 'ไม่พบตั๋ว',
    createNewTicket: 'สร้างตั๋วใหม่',
    allTickets: 'ตั๋วทั้งหมด',
    viewMode: 'โหมดการแสดงผล',
    list: 'รายการ',
    table: 'ตาราง',
    filterTickets: 'กรองตั๋ว',
    filterByStatus: 'กรองตามสถานะ',
    ticketDetails: 'รายละเอียดตั๋ว',
    view: 'ดู',
    tableView: 'ตาราง',
    listView: 'รายการ',
    kanbanView: 'บอร์ดคันบัน',
    totalTickets: 'ตั๋วทั้งหมด',
    hideFilters: 'ซ่อนตัวกรอง',
    showFilters: 'แสดงตัวกรอง',
    kanbanBoard: {
      dragToReorder: 'ลากเพื่อจัดเรียงใหม่',
      private: 'ส่วนตัว',
      createdBy: 'สร้างโดย:',
      assignedTo: 'มอบหมายให้:',
      created: 'สร้าง',
      updated: 'อัปเดต'
    },
    uploadFiles: 'อัปโหลดไฟล์',
    orDragAndDrop: 'หรือลากและวาง',
    anyFileUpTo: 'ไฟล์ใดก็ได้ขนาดไม่เกิน 10MB',
    deleteAttachment: 'ลบไฟล์แนบ',
    download: 'ดาวน์โหลด',
    unknown: 'ไม่ทราบ',

    bulkActions: {
      changeStatus: 'เปลี่ยนสถานะ',
      confirmTitle: 'ยืนยันการเปลี่ยนสถานะ',
      confirmMessage:
        'คุณแน่ใจหรือไม่ที่จะเปลี่ยนสถานะของ {{count}} รายการเป็น <strong>{{status}}</strong>? การกระทำนี้ไม่สามารถยกเลิกได้',
      confirm: 'ยืนยัน'
    },
    selected: 'เลือกแล้ว',
    removeAttachment: 'ลบไฟล์แนบ',
    maxFileSize: 'ไฟล์ละสูงสุด 50MB',
    uploadFile: 'อัปโหลดไฟล์',
    dragndrop: ' หรือลากวาง'
  },

  // Profile
  profile: {
    uploadPicture: 'อัปโหลดรูปโปรไฟล์',
    selectImageFile: 'กรุณาเลือกไฟล์ภาพ',
    imageSizeLimit: 'ขนาดภาพควรน้อยกว่า 5MB',
    uploadSuccess: 'อัปโหลดรูปโปรไฟล์สำเร็จ',
    uploadFailed: 'อัปโหลดรูปโปรไฟล์ไม่สำเร็จ',
    changePassword: 'เปลี่ยนรหัสผ่าน',
    personalInfo: 'ข้อมูลส่วนตัว',
    updateProfile: 'อัปเดตโปรไฟล์',
    fullName: 'ชื่อเต็ม',
    email: 'อีเมล',
    role: 'บทบาท',
    lastLogin: 'เข้าสู่ระบบครั้งล่าสุด',
    joinedOn: 'เข้าร่วมเมื่อ'
  },

  // Metadata
  metadata: {
    addNew: 'เพิ่มใหม่',
    edit: 'แก้ไข',
    save: 'บันทึก',
    create: 'สร้าง',
    delete: 'ลบ',
    name: 'ชื่อ',
    description: 'คำอธิบาย',
    actions: 'การดำเนินการ',
    confirmDelete: 'ยืนยันการลบ',
    deleteConfirmation: 'คุณแน่ใจหรือไม่ที่จะลบ {{name}}? การกระทำนี้ไม่สามารถยกเลิกได้',
    failedToFetch: 'ไม่สามารถดึงข้อมูล',
    failedToSave: 'ไม่สามารถบันทึกข้อมูล',
    failedToDelete: 'ไม่สามารถลบข้อมูล'
  },

  // Page Headers
  pageHeaders: {
    dashboard: {
      title: 'แดชบอร์ด',
      enhancedTitle: 'แดชบอร์ด',
      enhancedSubtitle: 'การวิเคราะห์ขั้นสูงและข้อมูลเชิงลึกสำหรับตั๋วของคุณ',
      topContributors: 'ผู้มีส่วนร่วมอันดับต้น',
      failedToLoadContributors: 'ไม่สามารถโหลดผู้มีส่วนร่วมอันดับต้น',
      failedToLoadTicketTrends: 'ไม่สามารถโหลดแนวโน้มตั๋ว',
      failedToLoadTrends: 'ไม่สามารถโหลดแนวโน้มตั๋ว',
      failedToLoadStats: 'ไม่สามารถโหลดสถิติแดชบอร์ด',
      createdTickets: 'ตั๋วที่สร้าง',
      closedTickets: 'ตั๋วที่ปิด',
      tickets: 'ตั๋ว',
      overview: 'ภาพรวม',
      quickStats: 'สถิติด่วน',
      ticketBreakdown: 'การแบ่งแยกตั๋ว',
      recentActivity: 'กิจกรรมล่าสุด',
      ticketTrends: 'แนวโน้มตั๋ว',
      trendsDescription: 'รูปแบบการสร้างและแก้ไขตั๋วรายวัน',
      statusBreakdown: 'การแบ่งตามสถานะ',
      statusDescription: 'การกระจายตั๋วตามสถานะปัจจุบัน',
      priorityDistribution: 'การกระจายความสำคัญ',
      priorityDescription: 'การแบ่งตั๋วตามระดับความสำคัญ',
      contributorsDescription: 'สมาชิกทีมที่มีกิจกรรมมากที่สุดตามตั๋วที่แก้ไข',
      ticketsCreated: 'ตั๋วที่สร้าง',
      ticketsClosed: 'ตั๋วที่ปิด',
      netChange: 'การเปลี่ยนแปลงสุทธิ',
      efficiency: 'ประสิทธิภาพ',
      totalCreated: 'สร้างทั้งหมด',
      totalClosed: 'ปิดทั้งหมด',
      backlogIncreased: 'งานค้างเพิ่มขึ้น',
      backlogDecreased: 'งานค้างลดลง',
      backlogStable: 'งานค้างเสถียร',
      noTrendData: 'ไม่มีข้อมูลแนวโน้มสำหรับช่วงวันที่ที่เลือก',
      totalTickets: 'ตั๋วทั้งหมด',
      quickInsights: 'ข้อมูลเชิงลึกด่วน',
      newTicketsNeedAttention: 'ตั๋วใหม่ต้องการความสนใจ',
      ticketsInProgress: 'ตั๋วกำลังดำเนินการในขณะนี้',
      ticketsAwaitingClosure: 'ตั๋วที่รอการปิด',
      allTimeTotal: 'ยอดรวมตลอดเวลา',
      dayAverage: '/วัน เฉลี่ย',
      backlogGrew: 'งานค้างเพิ่มขึ้น',
      backlogShrank: 'งานค้างลดลง',
      stable: 'เสถียร',
      resolutionRate: 'อัตราการแก้ไข',
      ticketCount: 'จำนวนตั๋ว',
      averagePriority: 'คะแนนความสำคัญเฉลี่ย',
      priorityScoreDesc: 'ค่าเฉลี่ยถ่วงน้ำหนัก (1=ต่ำ, 4=เร่งด่วน)',
      urgentAttention: 'ต้องการความสนใจเร่งด่วน',
      urgentTicketsMessage: 'ตั๋วเร่งด่วนต้องการความสนใจทันที',
      completionRate: 'อัตราการเสร็จสิ้น',
      ticketsCompleted: 'ตั๋วที่เสร็จสิ้น',
      avgResponseTime: 'เวลาตอบสนองเฉลี่ย',
      averageFirstResponse: 'การตอบสนองครั้งแรกเฉลี่ย',
      activeTickets: 'ตั๋วที่ใช้งานอยู่',
      newAndProcessing: 'ใหม่และกำลังดำเนินการ',
      performanceSummary: 'สรุปประสิทธิภาพ',
      workloadDistribution: 'การกระจายภาระงาน',
      newTickets: 'ใหม่',
      processing: 'กำลังดำเนินการ',
      resolved: 'แก้ไขแล้ว',
      priorityBreakdown: 'การแบ่งตามความสำคัญ',
      urgent: 'เร่งด่วน',
      high: 'สูง',
      medium: 'ปานกลาง',
      keyInsights: 'ข้อมูลเชิงลึกสำคัญ',
      excellentCompletion: 'อัตราการเสร็จสิ้นยอดเยี่ยม',
      noUrgentTickets: 'ไม่มีตั๋วเร่งด่วน',
      managableWorkload: 'ภาระงานที่จัดการได้',
      active: 'ใช้งานอยู่',
      progress: 'ความคืบหน้า',
      inProgress: 'กำลังดำเนินการ',
      total: 'รวม',
      noContributorsData: 'ไม่มีข้อมูลผู้มีส่วนร่วมสำหรับช่วงวันที่ที่เลือก',
      teamSummary: 'สรุปทีม',
      totalResolved: 'แก้ไขทั้งหมด',
      totalInProgress: 'กำลังดำเนินการทั้งหมด',
      topPerformer: 'ผู้ปฏิบัติงานดีเด่น',
      errorTitle: 'เกิดข้อผิดพลาดในการโหลดแดชบอร์ด',
      searchError: 'ข้อผิดพลาดการค้นหา',
      separator: '•'
    },
    tickets: {
      title: 'ตั๋ว',
      allTickets: 'ตั๋วทั้งหมด',
      viewMode: 'โหมดการแสดงผล',
      list: 'รายการ',
      table: 'ตาราง',
      kanban: 'คันบัน',
      filterTickets: 'กรองตั๋ว',
      ticketDetails: 'รายละเอียดตั๋ว',
      view: 'ดู',
      tableView: 'ตาราง',
      listView: 'รายการ',
      kanbanView: 'บอร์ดคันบัน',
      totalTickets: 'ตั๋วทั้งหมด',
      allStatuses: 'สถานะทั้งหมด',
      requestedBy: 'ขอโดย',
      assignedTo: 'มอบหมายให้',
      filterByGroups: 'กรองตามกลุ่ม...',
      filterByRequesters: 'กรองตามผู้ขอ...',
      filterByAssignees: 'กรองตามผู้รับผิดชอบ...',
      hideFilters: 'ซ่อนตัวกรอง',
      showFilters: 'แสดงตัวกรอง',
      noTicketsFound: 'ไม่พบตั๋ว',
      kanbanBoard: {
        dragToReorder: 'ลากเพื่อจัดเรียงใหม่',
        private: 'ส่วนตัว',
        createdBy: 'สร้างโดย:',
        assignedTo: 'มอบหมายให้:',
        created: 'สร้าง',
        updated: 'อัปเดต'
      }
    },
    createTicket: {
      title: 'สร้างตั๋ว',
      newTicket: 'ตั๋วใหม่',
      basicInfo: 'ข้อมูลพื้นฐาน',
      additionalDetails: 'รายละเอียดเพิ่มเติม',
      error: 'ไม่สามารถสร้างตั๋วได้',
      createButton: 'สร้างตั๋ว',
      fields: {
        title: 'หัวข้อตั๋ว',
        titlePlaceholder: 'สรุปสั้นๆ ของปัญหา',
        source: 'แหล่งที่มา',
        category: 'หมวดหมู่',
        type: 'ประเภท',
        assignToGroup: 'มอบหมายให้กลุ่ม',
        assignToAgent: 'มอบหมายให้เอเจนต์',
        tags: 'แท็ก',
        tagsPlaceholder: 'เลือกหรือค้นหาแท็ก...',
        noTagsAvailable: 'ไม่มีแท็ก',
        typeAtLeastOneChar: 'พิมพ์อย่างน้อย 1 ตัวอักษร',
        noMatchingTags: 'ไม่พบแท็กที่ตรงกัน',
        loadingTags: 'กำลังโหลดแท็ก...',
        ticketDetails: 'รายละเอียดตั๋ว',
        description: 'คำอธิบาย',
        descriptionPlaceholder: 'คำอธิบายรายละเอียดของปัญหา...',
        templates: 'แม่แบบ',
        selectTemplate: 'เลือกแม่แบบฟอร์ม',
        loadingTemplates: 'กำลังโหลดแม่แบบ...',
        notifyCustomer: 'แจ้งเตือนลูกค้า',
        notifyCustomerDescription: 'แจ้งเตือนลูกค้าเกี่ยวกับตั๋วผ่านการแจ้งเตือนแบบพุช'
      }
    },
    reports: {
      title: 'รายงาน',
      ticketStats: 'สถิติตั๋ว',
      exportData: 'ส่งออกข้อมูล',
      dateRangeReport: 'รายงานช่วงวันที่',
      ticketsExport: 'ตั๋ว',
      exporting: 'กำลังส่งออก...',
      export: 'ส่งออก'
    },
    settings: {
      title: 'การตั้งค่า',
      account: 'บัญชี',
      preferences: 'การตั้งค่า',
      notifications: 'การแจ้งเตือน',
      security: 'ความปลอดภัย'
    },
    myMemo: {
      title: 'บันทึกของฉัน',
      createMemo: 'สร้างบันทึก',
      editMemo: 'แก้ไขบันทึก',
      deleteMemo: 'ลบบันทึก',
      newMemo: 'บันทึกใหม่',
      arrangeInGrid: 'จัดเรียงในตาราง',
      loadError: 'ไม่สามารถโหลดบันทึก',
      createError: 'ไม่สามารถสร้างบันทึก',
      updateError: 'ไม่สามารถอัปเดตบันทึก',
      deleteError: 'ไม่สามารถลบบันทึก',
      loginRequired: 'กรุณาเข้าสู่ระบบเพื่อดูบันทึกของคุณ',
      searchPlaceholder: 'ค้นหาบันทึก...',
      memoCount: 'บันทึก {{count}} รายการ',
      noMemos: 'ยังไม่มีบันทึก',
      noMatchingMemos: 'ไม่มีบันทึกที่ตรงกัน',
      tryDifferentSearch: 'ลองใช้คำค้นหาที่แตกต่างกัน',
      createFirstMemo: 'สร้างบันทึกแรกของคุณเพื่อเริ่มต้น',
      createNewMemo: 'สร้างบันทึกใหม่'
    },
    changePassword: {
      title: 'เปลี่ยนรหัสผ่าน',
      currentPassword: 'รหัสผ่านปัจจุบัน',
      newPassword: 'รหัสผ่านใหม่',
      confirmPassword: 'ยืนยันรหัสผ่าน',
      success: 'เปลี่ยนรหัสผ่านสำเร็จ',
      failedToChange: 'ไม่สามารถเปลี่ยนรหัสผ่าน',
      validation: {
        currentRequired: 'จำเป็นต้องระบุรหัสผ่านปัจจุบัน',
        minLength: 'รหัสผ่านใหม่ต้องมีอย่างน้อย 6 ตัวอักษร',
        maxLength: 'รหัสผ่านใหม่ต้องไม่เกิน 50 ตัวอักษร',
        confirmRequired: 'กรุณายืนยันรหัสผ่านใหม่ของคุณ',
        passwordsDontMatch: 'รหัสผ่านไม่ตรงกัน'
      }
    },
    contact: {
      title: 'ติดต่อ',
      contactForm: 'แบบฟอร์มติดต่อ',
      sendMessage: 'ส่งข้อความ',
      contactInfo: 'ข้อมูลติดต่อ',
      subtitle: 'ติดต่อทีมของเรา',
      officeHours: 'เวลาทำการ',
      headquarters: 'สำนักงานใหญ่'
    },
    privacyPolicy: {
      title: 'นโยบายความเป็นส่วนตัว'
    },
    termsOfService: {
      title: 'ข้อกำหนดการใช้บริการ'
    },
    landing: {
      title: 'FlowCXP - แพลตฟอร์มประสบการณ์ลูกค้า',
      subtitle: 'ปรับปรุงการสนับสนุนลูกค้าของคุณด้วยระบบตั๋วที่ทันสมัย',
      nav: {
        signIn: 'เข้าสู่ระบบ',
        getStarted: 'เริ่มต้น'
      },
      hero: {
        transparentPricing: 'ราคาโปร่งใสที่ $15-20/เอเจนต์',
        premiumFeatures: 'รวมคุณสมบัติพรีเมียมทั้งหมด',
        exceptionalValue: 'คุณค่าพิเศษสำหรับทีมทุกขนาด',
        modernInterface: 'อินเทอร์เฟซ React ที่ทันสมัยและรวดเร็ว',
        realtimeUpdates: 'อัปเดตและการแจ้งเตือนแบบเรียลไทม์',
        boostProductivity: 'เพิ่มประสิทธิภาพทีม 40%',
        comprehensiveFeatures: 'ชุดคุณสมบัติครบครัน',
        everyFeature: 'ทุกคุณสมบัติรวมอยู่ในทุกแผน',
        predictablePricing: 'ราคาที่คาดเดาได้ ไม่มีเซอร์ไพรส์',
        startTrial: 'เริ่มทดลองใช้ฟรี 14 วัน',
        noCreditCard: 'ไม่ต้องใช้บัตรเครดิต เข้าถึงคุณสมบัติทั้งหมด'
      },
      featuresTitle: 'ออกแบบสำหรับทีมสนับสนุนสมัยใหม่',
      features: {
        dashboard: {
          name: 'แดชบอร์ดที่ใช้งานง่าย',
          description: 'ดูภาพรวมที่ครอบคลุมของกิจกรรมสนับสนุนทั้งหมดด้วยแดชบอร์ดที่ปรับแต่งได้',
          alt: 'อินเทอร์เฟซแดชบอร์ดแสดงสถิติตั๋วและกิจกรรม'
        },
        views: {
          name: 'มุมมองที่ยืดหยุ่น',
          description:
            'สลับระหว่างมุมมองคันบัน ตาราง และการ์ดเพื่อจัดการเวิร์กโฟลว์ตามที่คุณต้องการ',
          alt: 'มุมมองบอร์ดคันบันของตั๋ว'
        },
        ticketManagement: {
          name: 'การจัดการตั๋วรายละเอียด',
          description: 'เข้าถึงรายละเอียดตั๋วทั้งหมดในที่เดียวด้วยมุมมองตั๋วที่ครอบคลุม',
          alt: 'มุมมองตั๋วรายละเอียดพร้อมข้อมูลทั้งหมด'
        },
        reporting: {
          name: 'การรายงานขั้นสูง',
          description: 'สร้างรายงานที่ให้ข้อมูลเชิงลึกเพื่อติดตามประสิทธิภาพและระบุแนวโน้ม',
          alt: 'อินเทอร์เฟซการรายงานพร้อมแผนภูมิและเมตริก'
        }
      },
      platformHighlights: 'จุดเด่นของแพลตฟอร์ม',
      pricing: {
        title: 'โซลูชันที่ปรับแต่งสำหรับธุรกิจของคุณ',
        description:
          'คุณสมบัติ FlowCXP ทั้งหมด—ตั๋ว เวิร์กโฟลว์ การวิเคราะห์ พอร์ทัล การเชื่อมต่อ—ออกแบบเพื่อขยายตามองค์กรของคุณ',
        period: 'ราคา',
        enterprise: {
          name: 'องค์กร',
          price: 'กำหนดเอง',
          description: 'ราคา SLA และตัวเลือกการปรับใช้ที่ปรับแต่งสำหรับธุรกิจทุกขนาด',
          seatLimit: 'ขนาดทีมใดก็ได้',
          cta: 'ขอดูการสาธิต',
          features: {
            all: 'รวมคุณสมบัติ FlowCXP ทั้งหมด',
            ticketing: 'ระบบตั๋วครบครัน',
            workflows: 'เวิร์กโฟลว์และระบบอัตโนมัติไม่จำกัด',
            sla: 'SLA และตัวเลือกการปรับใช้แบบกำหนดเอง',
            accountManager: 'ผู้จัดการบัญชีเฉพาะ',
            prioritySupport: 'การสนับสนุนลำดับความสำคัญ',
            integrations: 'การเชื่อมต่อแบบกำหนดเอง'
          }
        }
      },
      forgotPassword: 'ลืมรหัสผ่าน'
    },
    login: {
      title: 'เข้าสู่ระบบ',
      welcome: 'ยินดีต้อนรับ',
      credentials: 'เข้าสู่ระบบด้วยข้อมูลประจำตัวของคุณ',
      forgotPassword: 'ลืมรหัสผ่าน'
    },
    registration: {
      title: 'ลงทะเบียน',
      createAccount: 'สร้างบัญชี',
      alreadyHaveAccount: 'มีบัญชีแล้ว'
    },
    checkout: {
      title: 'ชำระเงิน',
      paymentDetails: 'รายละเอียดการชำระเงิน',
      billingInfo: 'ข้อมูลการเรียกเก็บเงิน',
      invalidPlan: 'เลือกแผนไม่ถูกต้อง',
      planNotFound: 'ไม่พบแผน',
      backToPricing: 'กลับไปที่ราคา',
      subscribingTo: 'สมัครสมาชิก {{planName}}'
    },
    paymentSuccess: {
      title: 'ชำระเงินสำเร็จ',
      thankYou: 'ขอบคุณสำหรับการซื้อ',
      orderDetails: 'รายละเอียดคำสั่งซื้อ'
    }
  },

  // Search
  search: {
    placeholder: 'ค้นหาตั๋ว... (เช่น @ticket_id: 123)',
    criteria: {
      ticketId: 'รหัสตั๋ว',
      ticketTitle: 'หัวข้อตั๋ว',
      ticketDescription: 'คำอธิบายตั๋ว',
      customerId: 'รหัสลูกค้า',
      customerName: 'ชื่อลูกค้า',
      customerPhone: 'โทรศัพท์ลูกค้า',
      customerReference: 'อ้างอิงลูกค้า'
    }
  },

  // Settings
  settings: {
    manageAgents: 'จัดการเอเจนต์',
    availableAgents: 'เอเจนต์ที่มีอยู่',
    currentAgents: 'เอเจนต์ปัจจุบัน',
    addSelected: 'เพิ่มที่เลือก',
    removeSelected: 'ลบที่เลือก',
    failedToLoadAgents: 'ไม่สามารถโหลดเอเจนต์',
    failedToAddAgents: 'ไม่สามารถเพิ่มเอเจนต์',
    failedToRemoveAgents: 'ไม่สามารถลบเอเจนต์',
    title: 'การตั้งค่า',
    sources: 'แหล่งที่มา',
    categories: 'หมวดหมู่',
    types: 'ประเภท',
    agents: 'เอเจนต์',
    groups: 'กลุ่ม',
    tags: 'แท็ก',
    templates: 'แม่แบบ',
    integrations: 'การเชื่อมต่อ',
    botConfiguration: 'การตั้งค่าบอท',
    billing: 'การเรียกเก็บเงิน',
    auditLogs: 'บันทึกการตรวจสอบ',
    accessDenied: 'คุณไม่มีสิทธิ์ในการดูการตั้งค่า กรุณาติดต่อผู้ดูแลระบบของคุณ',
    billingAccessDenied:
      'คุณไม่มีสิทธิ์เข้าถึงการตั้งค่าการเรียกเก็บเงิน คุณสมบัตินี้ต้องการสิทธิ์ผู้ดูแลระบบสูงสุด',
    userManagement: {
      title: 'เอเจนต์สนับสนุน',
      description: 'จัดการเอเจนต์สนับสนุนที่สามารถจัดการตั๋วได้',
      addNew: 'เพิ่มใหม่',
      me: 'ฉัน',
      resetPassword: 'รีเซ็ตรหัสผ่าน',
      cannotDeleteOwnAccount: 'คุณไม่สามารถลบบัญชีของตัวเองได้',
      deleteAgent: 'ลบเอเจนต์',
      confirmDelete: 'คุณแน่ใจหรือไม่ที่จะลบ',
      tempPasswordGenerated: 'สร้างรหัสผ่านชั่วคราวแล้ว',
      resetPasswordTitle: 'รีเซ็ตรหัสผ่าน',
      confirmResetPassword: 'คุณแน่ใจหรือไม่ที่จะรีเซ็ตรหัสผ่านสำหรับ',
      tempPasswordMessage: 'สร้างรหัสผ่านชั่วคราวสำหรับ',
      copyToClipboard: 'คัดลอกไปยังคลิปบอร์ด',
      editAgent: 'แก้ไข',
      addAgent: 'เพิ่ม',
      fullName: 'ชื่อเต็ม',
      phone: 'โทรศัพท์',
      email: 'อีเมล',
      password: 'รหัสผ่าน',
      role: 'บทบาท',
      totalAgents: 'เอเจนต์ทั้งหมด',
      roles: {
        agent: 'เอเจนต์',
        admin: 'ผู้ดูแลระบบ',
        requester: 'ผู้ขอ'
      },
      saveChanges: 'บันทึกการเปลี่ยนแปลง',
      create: 'สร้าง',
      columns: {
        name: 'ชื่อ',
        phone: 'โทรศัพท์',
        email: 'อีเมล',
        role: 'บทบาท',
        actions: 'การดำเนินการ'
      },
      errors: {
        fetchFailed: 'ไม่สามารถดึงข้อมูลผู้ใช้',
        saveFailed: 'ไม่สามารถบันทึกผู้ใช้',
        deleteFailed: 'ไม่สามารถลบผู้ใช้'
      },
      success: {
        userSaved: 'บันทึกผู้ใช้สำเร็จ',
        userDeleted: 'ลบผู้ใช้สำเร็จ'
      }
    },
    categoryManagement: {
      title: 'หมวดหมู่',
      description: 'กำหนดค่าหมวดหมู่ต่างๆ เพื่อจำแนกตั๋ว'
    },
    typeManagement: {
      title: 'ประเภท',
      description: 'กำหนดค่าประเภทของตั๋วที่สามารถสร้างได้'
    },
    sourceManagement: {
      title: 'แหล่งที่มา',
      description: 'กำหนดค่าแหล่งที่มาและช่องทางต่างๆ ที่สามารถสร้างตั๋วได้'
    },
    groupManagement: {
      title: 'กลุ่ม',
      description: 'กำหนดค่ากลุ่มต่างๆ เพื่อจำแนกตั๋ว'
    },
    tagManagement: {
      title: 'แท็ก',
      description: 'กำหนดค่าแท็กเพื่อการจัดระเบียบและกรองตั๋วที่ดีขึ้น'
    },
    ticketTitleSuggestions: {
      title: 'คำแนะนำชื่อตั๋ว',
      description: 'กำหนดค่าคำแนะนำชื่อตั๋วอัตโนมัติตามแท็กที่เลือก',
      enableFeature: 'เปิดใช้งานการแนะนำชื่อ',
      enableDescription: 'เมื่อเปิดใช้งาน ผู้ใช้จะเห็นชื่อที่แนะนำตามแท็กที่เลือกเมื่อสร้างตั๋ว',
      manageSuggestions: 'จัดการคำแนะนำ',
      manageSuggestionsDescription: 'เพิ่มและจัดการคำแนะนำชื่อสำหรับแต่ละแท็กในหน้าตั้งค่าแท็ก',
      noSuggestionsAvailable: 'ไม่มีคำแนะนำสำหรับแท็กที่เลือก',
      selectFromSuggestions: 'เลือกจากคำแนะนำหรือกรอกเอง',
      suggestedTitles: 'ชื่อที่แนะนำ',
      enterManually: 'หรือกรอกชื่อด้วยตนเอง',
      autoGenerated: 'ชื่อถูกสร้างอัตโนมัติตามแท็กที่เลือก',
      settingsSaved: 'บันทึกการตั้งค่าคำแนะนำชื่อตั๋วเรียบร้อยแล้ว',
      settingsError: 'เกิดข้อผิดพลาดในการบันทึกการตั้งค่า',
      autoTitleToggle: 'สร้างชื่อตั๋วอัตโนมัติ',
      autoTitleDescription: 'กรอกชื่อตั๋วโดยอัตโนมัติตามแท็กที่เลือก'
    },
    templateManagement: {
      title: 'แม่แบบ',
      description: 'กำหนดค่าแม่แบบสำหรับการสร้างตั๋ว'
    },
    integrationManagement: {
      title: 'การตั้งค่าการเชื่อมต่อ',
      description: 'กำหนดค่าการเชื่อมต่อสำหรับการสร้างตั๋ว'
    },
    integrationSettings: {
      externalReference: {
        title: 'การเชื่อมต่อข้อมูลอ้างอิงภายนอก',
        description: 'กำหนดค่าการเชื่อมต่อ ID ข้อมูลอ้างอิงภายนอกสำหรับการสร้างตั๋ว',
        enable: 'เปิดใช้งานการเชื่อมต่อข้อมูลอ้างอิงภายนอก',
        enableDescription: 'เปิดใช้งานการเชื่อมต่อกับบริการ ID ข้อมูลอ้างอิงภายนอก',
        apiUrl: 'URL API',
        apiUrlDescription: 'URL หลักของ API บริการข้อมูลอ้างอิงภายนอก',
        apiKey: 'คีย์ API',
        apiKeyDescription: 'คีย์การยืนยันตัวตนสำหรับเข้าถึงบริการข้อมูลอ้างอิงภายนอก',
        apiKeyHeader: 'ชื่อ Header คีย์ API',
        apiKeyHeaderDescription:
          "ชื่อ header สำหรับคีย์ API (เช่น 'key', 'Authorization', 'X-API-Key')",
        timeout: 'หมดเวลา (ms)',
        timeoutDescription: 'หมดเวลาการร้องขอในหน่วยมิลลิวินาที (ค่าเริ่มต้น: 5000)',
        phoneField: 'พารามิเตอร์ฟิลด์โทรศัพท์',
        phoneFieldDescription:
          "ชื่อพารามิเตอร์สำหรับหมายเลขโทรศัพท์ใน API payload (เช่น 'phone', 'phoneNumber', 'mobile')",
        contentType: 'Content Type',
        contentTypeDescription: 'Content-Type header สำหรับการร้องขอ API',
        testTitle: 'ทดสอบการรวมระบบ',
        testDescription: 'ทดสอบการเชื่อมต่อกับบริการอ้างอิงภายนอก',
        success: 'โหลดข้อมูลลูกค้าสำเร็จแล้ว',
        error: 'ไม่สามารถโหลดข้อมูลลูกค้าได้',
        searchTitle: 'ค้นหาข้อมูลอ้างอิงภายนอก'
      }
    },
    billingManagement: {
      title: 'การจัดการการเรียกเก็บเงิน',
      description: 'กำหนดค่าการเรียกเก็บเงินสำหรับการสร้างตั๋ว'
    },
    // ... (rest of the code remains the same)
    notifications: {
      integrationSettings: 'การตั้งค่าการเชื่อมต่อ',
      enable: 'เปิดใช้งานการแจ้งเตือนแบบพุช',
      apiUrl: 'URL API',
      authKey: 'คีย์การยืนยันตัวตน',
      notificationId: 'ID การแจ้งเตือน',
      notificationIdDesc: 'ID การแจ้งเตือนที่ใช้โดยบริการแจ้งเตือนภายนอก',
      channelType: 'ประเภทช่องทาง',
      channelPush: 'พุช',
      channelEmail: 'อีเมล',
      channelSms: 'SMS',
      clientType: 'ประเภทไคลเอนต์',
      defaultIcon: 'URL ไอคอนเริ่มต้น',
      saveSettings: 'บันทึกการตั้งค่า',
      saving: 'กำลังบันทึก...',
      testPushNotification: 'ทดสอบการแจ้งเตือนแบบพุช',
      customerId: 'ID ลูกค้า',
      sendTest: 'ส่งการแจ้งเตือนทดสอบ',
      sending: 'กำลังส่ง...',
      testSuccess: 'ส่งการแจ้งเตือนทดสอบสำเร็จ',
      errorTest: 'เกิดข้อผิดพลาดในการส่งการแจ้งเตือนทดสอบ',
      errorTestAlert: 'เกิดข้อผิดพลาดในการส่งการแจ้งเตือนทดสอบ: ',
      settingsSaved: 'บันทึกการตั้งค่าสำเร็จ',
      settingsError: 'เกิดข้อผิดพลาดในการบันทึกการตั้งค่า'
    }
  },

  // Reports
  reports: {
    performance: {
      ticketsResolved: 'ตั๋วที่แก้ไข',
      avgResponseTime: 'เวลาตอบสนองเฉลี่ย (นาที)',
      agentMetrics: 'เมตริกประสิทธิภาพเอเจนต์',
      avgResolutionTime: 'เวลาแก้ไขเฉลี่ย',
      firstResponseTime: 'เวลาตอบสนองครั้งแรก',
      customerSatisfaction: 'ความพึงพอใจของลูกค้า'
    },
    filters: {
      title: 'ตัวกรอง',
      dateRange: 'ช่วงวันที่',
      status: 'สถานะ',
      allStatuses: 'สถานะทั้งหมด',
      priority: 'ความสำคัญ',
      allPriorities: 'ความสำคัญทั้งหมด',
      type: 'ประเภท',
      allTypes: 'ประเภททั้งหมด',
      group: 'กลุ่ม',
      allGroups: 'กลุ่มทั้งหมด'
    },
    sla: {
      responseTime: 'SLA เวลาตอบสนอง',
      resolutionTime: 'SLA เวลาแก้ไข',
      complianceOverTime: 'การปฏิบัติตาม SLA ตามเวลา (%)',
      compliance: 'การปฏิบัติตาม SLA',
      firstResponse: 'การตอบสนองครั้งแรก',
      target: 'เป้าหมาย: '
    },
    trends: {
      newTickets: 'ตั๋วใหม่',
      volumeTrends: 'แนวโน้มปริมาณตั๋ว',
      totalVolume: 'ปริมาณรวม',
      avgResolutionTime: 'เวลาแก้ไขเฉลี่ย',
      customerSatisfaction: 'ความพึงพอใจของลูกค้า',
      firstContactResolution: 'การแก้ไขในการติดต่อครั้งแรก',
      topCategories: 'หมวดหมู่อันดับต้น',
      priorityDistribution: 'การกระจายความสำคัญ',
      vsLastMonth: 'เทียบกับเดือนที่แล้ว',
      categories: {
        technical: 'ปัญหาทางเทคนิค',
        billing: 'คำถามเกี่ยวกับการเรียกเก็บเงิน',
        feature: 'คำขอคุณสมบัติ',
        other: 'อื่นๆ'
      },
      priorities: {
        urgent: 'เร่งด่วน',
        high: 'สูง',
        medium: 'ปานกลาง',
        low: 'ต่ำ'
      }
    }
  },

  // Memo
  memo: {
    title: 'หัวข้อ',
    content: 'เนื้อหา',
    color: 'สี',
    titleRequired: 'จำเป็นต้องระบุหัวข้อ',
    contentRequired: 'จำเป็นต้องระบุเนื้อหา',
    titlePlaceholder: 'หัวข้อบันทึก',
    contentPlaceholder: 'เขียนบันทึกของคุณที่นี่...',
    saveFailed: 'ไม่สามารถบันทึกบันทึก กรุณาลองใหม่อีกครั้ง',
    deleteConfirm: 'ลบบันทึกนี้หรือไม่?',
    saving: 'กำลังบันทึก...',
    saveMemo: 'บันทึกบันทึก'
  },

  // Theme and UI
  theme: {
    switchToLight: 'เปลี่ยนเป็นโหมดสว่าง',
    switchToDark: 'เปลี่ยนเป็นโหมดมืด',
    openMenu: 'เปิดเมนูหลัก'
  },

  // Errors
  errors: {
    applicationError: 'ข้อผิดพลาดของแอปพลิเคชัน',
    goBack: 'กลับ',
    goHome: 'กลับหน้าหลัก'
  },

  // Omni-Channel Integration
  atrium: {
    shortTitle: 'Atrium',
    title: 'The Atrium Integration',
    description:
      'เชื่อมต่อช่องทางการสื่อสารหลายช่องทางเพื่อจัดการการโต้ตอบกับลูกค้าทั้งหมดในที่เดียว',
    comingSoon: 'เร็วๆ นี้...',
    conversations: 'The Atrium การสนทนา',
    noConversations: 'ไม่พบการสนทนา',
    overview: 'The Atrium ภาพรวม',
    activeChannels: '{{count}} ช่องทางที่ใช้งานอยู่',
    activeChannels_plural: '{{count}} ช่องทางที่ใช้งานอยู่',
    realtimeStats: 'สถิติข้อความแบบเรียลไทม์',
    settings: 'The Atrium การตั้งค่า',
    agentStats: 'The Atrium สถิติและตัวชี้วัดของเจ้าหน้าที่',
    filters: {
      title: 'ตัวกรอง',
      active: 'ใช้งานอยู่',
      clearAll: 'ล้างทั้งหมด',
      searchPlaceholder: 'ค้นหาการสนทนา...',
      status: 'สถานะ',
      priority: 'ลำดับความสำคัญ',
      channel: 'ช่องทาง',
      assignedTo: 'มอบหมายให้',
      allConversations: 'การสนทนาทั้งหมด',
      unassigned: 'ยังไม่ได้มอบหมาย'
    },
    selectConversation: 'เลือกการสนทนาเพื่อดูรายละเอียด',
    messenger: {
      description: 'เชื่อมต่อกับลูกค้าผ่าน Facebook Messenger',
      title: 'เชื่อมต่อ Facebook Messenger',
      subtitle: 'เปิดให้ลูกค้าของคุณติดต่อคุณผ่าน Facebook Messenger',
      beforeStart: 'ก่อนเริ่มต้น',
      beforeStartDesc:
        'คุณจะต้องมี Facebook Page และ Facebook App ที่เปิดใช้งาน Messenger ทำตามขั้นตอนเหล่านี้เพื่อรับข้อมูลรับรองของคุณ',
      stepByStep: 'คู่มือทีละขั้นตอน:',
      continueBtn: 'ฉันมีข้อมูลรับรองแล้ว ดำเนินการต่อ',
      continueToTesting: 'ดำเนินการต่อไปยังการทดสอบ',
      successMessage: 'กำหนดค่าช่องทาง Messenger สำเร็จแล้ว!',
      setupWebhook: 'ตั้งค่า Facebook Webhook',
      setupWebhookDesc: 'ก่อนทดสอบ คุณต้องกำหนดค่า webhook ใน Facebook App ของคุณ',
      webhookStep1: 'ไปที่ Messenger Settings ใน Facebook App ของคุณ',
      webhookStep2: 'ค้นหาส่วน "Webhooks"',
      webhookStep3: 'คลิก "Add Callback URL"',
      webhookStep4: 'ใช้ URL และ verify token ด้านล่าง',
      webhookUrl: 'Webhook Callback URL',
      verifyTokenFacebook: 'Verify Token (ใช้ใน Facebook)',
      subscribeFields: 'สมัครรับ webhook fields เหล่านี้:',
      testConnection: 'ทดสอบการเชื่อมต่อ',
      testConnectionDesc: 'ตรวจสอบให้แน่ใจว่า webhook ของคุณได้รับการยืนยันใน Facebook ก่อนทดสอบ',
      testBtn: 'ทดสอบการเชื่อมต่อ',
      connectionSuccess: 'เชื่อมต่อสำเร็จ!',
      connectionFailed: 'การเชื่อมต่อล้มเหลว',
      activateBtn: 'เปิดใช้งานช่องทาง Messenger',
      steps: {
        setup: 'ตั้งค่า Facebook',
        config: 'การกำหนดค่า',
        test: 'ทดสอบและเปิดใช้งาน'
      },
      guide: {
        step1: {
          title: 'ไปที่ Facebook Developers',
          desc: 'เยี่ยมชม developers.facebook.com และสร้างแอปใหม่'
        },
        step2: {
          title: 'เพิ่ม Messenger Product',
          desc: 'ในแดชบอร์ดแอปของคุณ เพิ่มผลิตภัณฑ์ Messenger'
        },
        step3: {
          title: 'เชื่อมต่อ Facebook Page ของคุณ',
          desc: 'เลือกเพจที่คุณต้องการรับข้อความ'
        },
        step4: {
          title: 'สร้าง Page Access Token',
          desc: 'คลิก "Generate Token" และคัดลอก (คุณจะต้องใช้ในขั้นตอนถัดไป)'
        },
        step5: {
          title: 'รับ App Secret ของคุณ',
          desc: 'ไปที่ Settings → Basic และคัดลอก App Secret ของคุณ'
        }
      },
      form: {
        pageId: 'Facebook Page ID',
        pageIdDesc: 'ค้นหาใน Facebook Page Settings → About → Page ID ของคุณ',
        pageAccessToken: 'Page Access Token',
        pageAccessTokenDesc: 'สร้างจาก Messenger Settings → Access Tokens ใน Facebook App ของคุณ',
        appSecret: 'App Secret',
        appSecretDesc: 'พบใน Settings → Basic ใน Facebook App ของคุณ',
        verifyToken: 'Verify Token',
        verifyTokenDesc: 'โทเค็นที่กำหนดเองสำหรับการยืนยัน webhook (สร้างแบบสุ่ม)'
      }
    },
    email: {
      description: 'รับและตอบกลับอีเมลของลูกค้า'
    },
    viber: {
      description: 'เชื่อมต่อกับลูกค้าผ่าน Viber'
    },
    channelStatus: {
      title: 'Facebook Messenger',
      subtitle: 'สถานะและการกำหนดค่าช่องทาง',
      active: 'ใช้งานอยู่',
      inactive: 'ไม่ได้ใช้งาน',
      connectedTo: 'เชื่อมต่อกับ Facebook Messenger',
      configuredButInactive: 'กำหนดค่าช่องทางแล้วแต่ไม่ได้ใช้งาน',
      pageId: 'Page ID',
      connectedOn: 'เชื่อมต่อเมื่อ',
      status: 'สถานะ',
      verified: 'ยืนยันแล้ว',
      totalConversations: 'การสนทนาทั้งหมด',
      messagesReceived: 'ข้อความที่ได้รับ',
      messagesSent: 'ข้อความที่ส่ง',
      lastActivity: 'กิจกรรมล่าสุด',
      viewConfig: 'ดูการกำหนดค่า',
      hideConfig: 'ซ่อนการกำหนดค่า',
      manageAccess: 'จัดการสิทธิ์การเข้าถึง',
      hideAccess: 'ซ่อนสิทธิ์การเข้าถึง',
      test: 'ทดสอบ',
      testing: 'กำลังทดสอบ...',
      disable: 'ปิดใช้งาน',
      enable: 'เปิดใช้งาน',
      processing: 'กำลังดำเนินการ...',
      configurationDetails: 'รายละเอียดการกำหนดค่า',
      dangerZone: 'พื้นที่อันตราย',
      dangerZoneWarning:
        'การยกเลิกการเชื่อมต่อช่องทางนี้จะลบข้อมูลการกำหนดค่าทั้งหมดอย่างถาวร การสนทนาที่ใช้งานอยู่ต้องได้รับการแก้ไขก่อน',
      disconnectChannel: 'ยกเลิกการเชื่อมต่อช่องทาง',
      disconnecting: 'กำลังยกเลิกการเชื่อมต่อ...'
    },
    liveChat: {
      title: 'ไลฟ์แชท (Live Chat)',
      description: 'เปิดใช้งานคีย์วิดเจ็ตเพื่อให้พาร์ทเนอร์สามารถฝัง Atrium ไลฟ์แชทของคุณได้',
      appId: 'รหัสแอป (App ID)',
      saveConfig: 'บันทึกการกำหนดค่า',
      embedSnippet: 'สนิปเป็ตสำหรับฝัง',
      domains: 'โดเมนที่อนุญาต',
      domainsHelp:
        'เพิ่มต้นทางเว็บไซต์ที่อนุญาต ใช้ต้นทางแบบเต็มเช่น https://my-site.com หรือโดเมนย่อยแบบไวลด์การ์ดเช่น https://*.my-site.com',
      personalization: 'การปรับแต่งส่วนบุคคล',
      widgetTitle: 'หัวข้อวิดเจ็ต',
      defaultWidgetTitle: 'ฝ่ายสนับสนุนสด',
      accentColor: 'สีเน้น',
      roundness: 'ความโค้งมน',
      roundnessNone: 'ไม่มี (เหลี่ยม)',
      roundnessNormal: 'ปกติ',
      roundnessFull: 'เต็ม (มน)',
      confirmRemove: 'ลบการกำหนดค่าไลฟ์แชทหรือไม่? การดำเนินการนี้จะยกเลิกคีย์วิดเจ็ต',
      errorLoad: 'โหลดการกำหนดค่าไลฟ์แชทไม่สำเร็จ',
      errorEnable: 'เปิดใช้งานไลฟ์แชทไม่สำเร็จ',
      errorRemove: 'ลบการกำหนดค่าไลฟ်แชทไม่สำเร็จ',
      errorCopy: 'คัดลอกไม่สำเร็จ',
      errorSave: 'บันทึกการกำหนดค่าไม่สำเร็จ',
      errorInvalidWildcard: 'โดเมนไวลด์การ์ดไม่ถูกต้อง: {{value}}',
      errorOnlyHttp: 'อนุญาตเฉพาะโดเมน http/https เท่านั้น: {{value}}',
      errorInvalidUrl: 'URL โดเมนไม่ถูกต้อง: {{value}}',
      widgetPosition: 'ตำแหน่งวิดเจ็ต',
      positionBottomRight: 'ล่างขวา',
      positionBottomLeft: 'ล่างซ้าย',
      positionTopRight: 'บนขวา',
      positionTopLeft: 'บนซ้าย',
      horizontalOffset: 'การปรับแนวขวาง (px)',
      verticalOffset: 'การปรับแนวตั้ง (px)',
      offsetHelp: 'ระยะห่างจากขอบหน้าจอเป็นพิกเซล'
    }
  },

  bot: {
    title: 'การตั้งค่าบอท',
    subtitle: 'กำหนดค่าการตอบกลับอัตโนมัติและพฤติกรรมของบอท',
    settings: 'การตั้งค่าบอท',
    rules: 'กฎของบอท',
    channel: 'ช่องทาง',
    selectChannel: 'เลือกช่องทาง',
    enableAutoReplies: 'เปิดใช้งานการตอบกลับอัตโนมัติของบอท',
    enableAutoRepliesDesc: 'เมื่อเปิดใช้งาน บอทจะตอบกลับข้อความของลูกค้าโดยอัตโนมัติ',
    messages: 'ข้อความ',
    greetingMessage: 'ข้อความทักทาย',
    optional: '(ไม่บังคับ)',
    greetingPlaceholder: 'สวัสดี! 👋 ยินดีต้อนรับสู่ FlowCXP! มีอะไรให้ช่วยไหมครับ?',
    greetingSent: 'ส่งโดยอัตโนมัติเมื่อเริ่มการสนทนาใหม่',
    fallbackMessage: 'ข้อความสำรอง',
    fallbackSent: 'ส่งเมื่อไม่มีกฎใดตรงกับข้อความของลูกค้า',
    statistics: 'สถิติ',
    totalRules: 'กฎทั้งหมด',
    activeRules: 'กฎที่ใช้งานอยู่',
    totalTriggers: 'จำนวนครั้งที่ใช้งาน',
    lastTriggered: 'ใช้งานล่าสุด',
    searchRules: 'ค้นหากฎ...',
    addRule: 'เพิ่มกฎ',
    noRulesYet: 'ยังไม่มีกฎที่สร้างขึ้น',
    createFirstRule: 'สร้างกฎแรกของคุณเพื่อเริ่มการตอบกลับอัตโนมัติ',
    whenCustomerSays: 'เมื่อลูกค้าพูดว่า',
    botRespondsWith: 'บอทตอบกลับด้วย',
    priority: 'ลำดับความสำคัญ',
    used: 'ใช้งาน',
    times: 'ครั้ง'
  }
};
